import Image from 'next/image';

import { BG_DARK, GAME_IMAGES, SHIELD_CYAN } from '../constants';

export function GameCarousel() {
  const games = [...GAME_IMAGES, ...GAME_IMAGES];
  const cardWidth = 190;
  const gap = 16;
  const totalWidth = GAME_IMAGES.length * (cardWidth + gap);

  return (
    <div className='relative w-full overflow-hidden' style={{ maskImage: 'linear-gradient(to right, transparent, black 8%, black 92%, transparent)', WebkitMaskImage: 'linear-gradient(to right, transparent, black 8%, black 92%, transparent)' }}>
      <div
        className='v5a-game-scroll flex gap-4'
        style={{ width: `${totalWidth * 2}px` }}
        onMouseEnter={(e) => {
          e.currentTarget.style.animationPlayState = 'paused';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.animationPlayState = 'running';
        }}
      >
        {games.map((game, i) => (
          <div key={`${game.name}-${i}`} className='group shrink-0' style={{ width: `${cardWidth}px` }}>
            <div className='relative overflow-hidden rounded-xl border transition-all duration-300 group-hover:border-opacity-60' style={{ borderColor: `${SHIELD_CYAN}20` }}>
              <Image src={game.src} alt={game.name} width={160} height={220} className='mx-auto h-[220px] w-[160px] object-cover transition-transform duration-300 group-hover:scale-105' />
              <div className='absolute inset-x-0 bottom-0 p-3' style={{ background: `linear-gradient(transparent, ${BG_DARK}E0)` }}>
                <span className='text-sm font-semibold text-white' style={{ fontFamily: 'var(--font-bai)' }}>
                  {game.name}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* The animation moved off the element's inline `style` and into this sheet so the rtl override
          below can reach it at all: an inline declaration outranks every stylesheet rule short of
          `!important`. `transform` is physical — CSS never mirrors it for writing direction — and this
          track is wider than its clip box, so under the `dir="rtl"` that /sa inherits from <html> it
          anchors to the RIGHT edge and overflows left, where the negative shift drags it out of the box
          instead of through it. The mirrored keyframes shift positive. */}
      <style
        dangerouslySetInnerHTML={{
          __html: `
            .v5a-game-scroll { animation: v5a-scroll-games ${GAME_IMAGES.length * 3}s linear infinite; }
            @keyframes v5a-scroll-games { 0% { transform: translateX(0); } 100% { transform: translateX(-${totalWidth}px); } }
            @keyframes v5a-scroll-games-rtl { 0% { transform: translateX(0); } 100% { transform: translateX(${totalWidth}px); } }
            [dir="rtl"] .v5a-game-scroll { animation-name: v5a-scroll-games-rtl; }
          `,
        }}
      />
    </div>
  );
}
